import React, { useState } from 'react'
import './App.css';
import Navbar from './Navbar';

function App() {
  const [appMode, setappMode] = useState('light');
  const toggleMode =() => {
    if(appMode==='dark'){
      setappMode('white');
      document.body.style.backgroundColor = 'white';
    }
    else {
      setappMode('dark');
      document.body.style.backgroundColor = 'black';
    }
  
  }
  return (
   <>
   <Navbar mode={appMode} toggle={toggleMode} title="WORDTRACK"/>
   </>
  );
}

export default App;
